<script setup lang="ts">
import type { ICrossSellProduct } from '~/interfaces/crossSell/ICrossSell';
import { isMobile } from '~/helpers/utils';

const props = defineProps<{
  title: string
  subtitle?: string
  crossSellItems: ICrossSellProduct[]
}>()

const {
  crossSellItems
} = toRefs(props)

const currentSlide = ref(0);
const startX = ref(0);
const endX = ref(0);
const translateValue = ref(0);
const sliderWrapper = ref(null);

const itemWidth = () => isMobile() ? 180 : 280;

const prevSlide = () => {
  currentSlide.value = (currentSlide.value - 1 + crossSellItems.value.length) % crossSellItems.value.length;
  translateValue.value = currentSlide.value * itemWidth();
}

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1 + crossSellItems.value.length) % crossSellItems.value.length;
  translateValue.value = currentSlide.value * itemWidth();
}

const startTouch = (e: TouchEvent) => {
  startX.value = e.touches[0].clientX;
}

const moveTouch = (e: TouchEvent) => {
  endX.value = e.touches[0].clientX;
  const diffX = startX.value - endX.value;
  translateValue.value = Math.abs(diffX) * 8;
}

</script>

<template>
  <div>
    <div class="carousel-v2__top">
      <div class="carousel-v2__title">
        <div v-if="title" class="size--body weight--intermedium">{{ title }}</div>
        <span v-if="subtitle" class="size--body">{{ subtitle }}</span>
      </div>
      <div class="carousel-v2__control-wrapper">
        <button
                :disabled="currentSlide === 0"
                :class="`control caroussel__control control__arrow ${ currentSlide !== 0 ? 'active' : ''}`"
                @click="prevSlide">
          <svg class="cicon pe-n">
            <use xlink:href="#left-v2"/>
          </svg>
        </button>
        <button
                :disabled="currentSlide === crossSellItems.length"
                :class="`control caroussel__control control__arrow ${currentSlide !== crossSellItems.length ? 'active' : ''}`"
                @click="nextSlide">
          <svg class="cicon pe-n">
            <use xlink:href="#right-v2"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="carousel-v2">
      <div
           ref="sliderWrapper"
           class="carousel-v2-inner"
           :style="{ transform: `translateX(-${translateValue}px)` }"
           @touchstart="startTouch" @touchmove="moveTouch">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>
